import { Component } from '@angular/core';
import { ViewController, AlertController, NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';
import { CustomToast } from '../../../../util/CustomToast';

@Component({
  selector: 'page-add-user',
  templateUrl: 'addUser.html',
  providers: [HttpClient, CustomToast]
})

export class AddUserPage {
    user;
    me;
    researchlines;
    persontypes;
    groups;

    active = false;
    password = '';
    password2 = '';

  	viewCtrl: ViewController;
  	navCtrl : NavController;
  	navParams : NavParams;
  	httpClient : HttpClient;
    baseUrl;

  	loadingCtrl : LoadingController;
    alertCtrl : AlertController;
    toastCtrl : ToastController;
    modalCtrl : ModalController;
    customToast : CustomToast;

    image = {
      id : -1,
      filename : 'addimage.png'
    };

    loading;

	constructor(viewCtrl: ViewController,alertCtrl : AlertController, navCtrl: NavController, navParams: NavParams, httpClient : HttpClient, loadingCtrl : LoadingController, toastCtrl : ToastController, modalCtrl : ModalController, customToast : CustomToast) {
		this.viewCtrl = viewCtrl;
		this.navParams = navParams;
		this.navCtrl = navCtrl;
		this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
		this.loadingCtrl = loadingCtrl;
    this.alertCtrl = alertCtrl;
    this.toastCtrl = toastCtrl;
    this.modalCtrl = modalCtrl;
    this.customToast = customToast;
    this.init();
    this.httpCallResearchLines();
    this.httpCallPersonTypes();
    this.httpCallGroups();
	}

  init(){
    this.user = {
      name : null,
      role : -1,
      surname1 : null,
      surname2 : null,
      username : null,
      phone : null,
      email : null,
      image : null,
      password : null,
      category_es : null,
      category_en : null,
      extension : null,
      institution : null,
      researcherid : null,
      google_scholar : null,
      scopus: null,
      external_link : null,
      research_line_id : null,
      person_type_id : null,
      summary_es : null,
      summary_en : null,
      tags_es : null,
      tags_en : null,
      group_id: -1,
    };
    
    this.httpClient.get('/users/me',(error,data)=>{
      this.me = data.json();
      if(this.me.role == 5) this.user.role = 2;
    });
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.user.image = image.filename;
      }
    });
  }

  httpCallResearchLines(){
    this.httpClient.get('/researchlines', (error,data)=>{
      if(!error){
        this.researchlines = data.json();
      }
    });
  }

  httpCallPersonTypes(){
    this.httpClient.get('/persontypes', (error,data)=>{
      if(!error){
        this.persontypes = data.json();
      }
    });
  }

  httpCallGroups() {
    this.httpClient.get("/groups", (error, data) => {
      if (!error) {
        this.groups = data.json();
      }
    });
  }

  httpCallCreateUser(){
    if(this.user.name && this.user.surname1 && this.user.role && this.user.person_type_id) {
      this.user.active = this.active==true?1:0;
      this.user.password = this.password;
      this.showLoading();
      this.httpClient.post('/users',this.user, (error,data)=>{
        if(!error){
          this.hideLoading();
          this.dismiss(true);
        }
      });
    } else {
      this.customToast.showMessage('Alguno de los campos requeridos no ha sido rellenado o está vacío', 5000);
    }
  }

  onClickSave(){
    if(this.password.trim().length > 0 && this.password == this.password2){
        let alert = this.alertCtrl.create({
        title : '¿Estas seguro?',message : 'Vas a crear un nuevo usuario',
        buttons:[{
          text : 'No',
          role : 'cancel'
          },
          {
          text : 'Si',
          role : 'confirm',
            handler : ()=>{
              this.httpCallCreateUser();
            }
          }
        ]
      });
      alert.present();
    }else{
      this.showMessage('Las contraseñas no coinciden',2000);
    }
  }

  showMessage(message,time){
    let toast = this.toastCtrl.create({
      message : message,
      duration : time,
      position : 'top'
    });
    toast.present();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Guardando la información...'
    });
    this.loading.present();
  }

  hideLoading(){
    this.loading.dismiss();
  }

  dismiss(reload){
    this.viewCtrl.dismiss(reload);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/users/addUser/addUser.ts